import { CgProfile } from 'react-icons/cg';
import styled from 'styled-components';
import { Colors, FontSize, FontWeight } from '../../../assets';
import { Link } from '../../elements';

export const Container = styled.div`
  background-color: ${Colors.primary};
  padding: 1rem;
  box-shadow: 0px 0px 20px 5px rgba(0, 0, 0, 0.33);
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: ${FontWeight.strong};
`;

export const Logo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 0.75rem;

  a {
    color: ${Colors.white};
    font-size: ${FontSize.icon};
  }

  a:hover {
    color: ${Colors.orange};
  }

  span {
    font-size: ${FontSize.small};
    color: ${Colors.white};
  }
`;

export const Navigation = styled.div`
  display: flex;
  flex-content: space-around;
  align-items: center;
  padding-right: 2rem;
`;

export const Icon = styled.span`
  font-size: ${FontSize.normal};
`;

export const HelpContainer = styled.div`
  padding-right: 2rem;
`;
export const HeaderLink = styled(Link)`
  color: ${Colors.white};

  &:hover {
    color: ${Colors.orange};
  }
`;

// border-left: 1px solid white;
export const ProfileContainer = styled.div`
  padding-left: 2rem;
  position: relative;

  &:before {
    background: #4f6b7e;
    width: 1px;
    content: '';
    position: absolute;
    left: 0px;
    top: 50%;
    margin-top: -14px;
    height: 28px;
  }
`;

export const ProfileSubContainer = styled.div`
  display: inline-box;
  position: absolute;
  top: 26px;
  right: -16px;
  padding-top: 20px;
  padding-right: 10px;
  opacity: 1;
  visibility: visible;
  z-index: 99;
`;

export const ToggleMenuContainer = styled.div`
  background-color: ${Colors.primary};
  min-width: 200px;
  box-sizing: border-box;
  position: relative;
  padding: 1rem;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

  &:before {
    position: absolute;
    content: '';
    right: 12px;
    bottom: 100%;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid ${Colors.primary};
  }

  & a {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;
    border-radius: 4px;
    transition: background-color 0.2s ease;
  }

  & a:hover {
    background-color: ${Colors.secondary};
    color: ${Colors.white};
  }
`;

export const ProfileIcon = styled(CgProfile)`
  font-size: ${FontSize.icon};
  color: ${Colors.white};
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${Colors.orange};
  }
`;

export const User = styled.div`
  color: ${Colors.white};
  font-size: ${FontSize.normal};
  font-weight: ${FontWeight.strong};
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  border-bottom: 1px solid ${Colors.secondary};
`;
